export enum ActionsPermission {
    PatientTask = 'patientTask',
}
